/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import VanillaTilt from "vanilla-tilt";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import lottie from "lottie-web";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    /** TOGGLE MENU */
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
        });
      });
    }

    /** ANCHOR */
    const links = document.querySelectorAll('a:not([href="#"])[href^="#"]');
    if (links && links.length > 0) {
      links.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          const target = document.querySelector(link.getAttribute("href"));

          if (target) {
            gsap.to(window, {
              scrollTo: {
                y: target,
              },
              ease: "expo.out",
              duration: 0.7,
            });
          }
        });
      });
    }

    this.marquee();
    this.textareaResize();
    this.accordion();
    this.cover();
    this.tilt();
    this.bodymovin();
    this.inViewport();
  }

  bodymovin() {
    const tags = document.querySelectorAll("[data-bodymovin]");

    if (tags) {
      tags.forEach((tag) => {
        tag.addEventListener("inview", () => {
          if (!tag.classList.contains("loaded")) {
            const anim = tag.dataset.bodymovin;
            // const path = `${WPTEMPLATE}/static/bodymovin/${anim}/data.json`;
            fetch(anim).then((response) => {
              if (response.status == 200) {
                const l = lottie.loadAnimation({
                  container: tag,
                  renderer: "svg",
                  loop: true,
                  autoplay: !(
                    tag.dataset.bodymovinAutoplay &&
                    tag.dataset.bodymovinAutoplay != "0"
                  ),
                  path: anim,
                });
                l.addEventListener("DOMLoaded", () => {
                  tag.classList.add("loaded");
                });
                tag.lottie = l;

                if (
                  tag.dataset.bodymovinAutoplay &&
                  tag.dataset.bodymovinAutoplay != ""
                ) {
                  setTimeout(() => {
                    l.play();
                    tag.classList.add("loaded");
                  }, Number.parseFloat(tag.dataset.bodymovinAutoplay) * 1000);
                } else {
                }
              }
            });
          } else if (tag.lottie) {
            tag.lottie.play();
          }
        });

        tag.addEventListener("outview", () => {
          if (tag.lottie) {
            // tag.lottie.pause();
          }
        });
      });
    }
  }

  textareaResize() {
    /**
     * Textarea
     */
    // expand height textarea
    function autoExpand(field) {
      // Reset field height
      field.style.height = "inherit";

      // Get the computed styles for the element
      const computed = window.getComputedStyle(field);

      // Calculate the height
      const height =
        Number.parseInt(computed.getPropertyValue("border-top-width"), 10) +
        // parseInt(computed.getPropertyValue('padding-top'), 10) +
        field.scrollHeight +
        // parseInt(computed.getPropertyValue('padding-bottom'), 10) +
        Number.parseInt(computed.getPropertyValue("border-bottom-width"), 10);

      field.style.height = `${height}px`;
    }

    document.addEventListener("input", (event) => {
      if (event.target.tagName.toLowerCase() !== "textarea") return;
      autoExpand(event.target);
    });
  }

  accordion() {
    const elts = document.querySelectorAll(".accordion");

    if (elts) {
      elts.forEach((el) => {
        const headers = el.querySelectorAll(".accordion-header");
        const contents = el.querySelectorAll(".accordion-content");
        const items = el.querySelectorAll(".accordion-item");

        if (headers && contents && items) {
          headers.forEach((header, i) => {
            header.addEventListener("click", (e) => {
              e.preventDefault();

              items[i].classList.toggle("active");

              gsap.to(contents[i], {
                autoAlpha: items[i].classList.contains("active") ? 1 : 0,
                height: items[i].classList.contains("active")
                  ? contents[i].scrollHeight
                  : 0,
                ease: "circ.inOut",
                duration: 0.4,
              });
            });
          });
        }
      });
    }
  }

  cover() {
    const elts = document.querySelectorAll(".cover");
    if (elts) {
      elts.forEach((el) => {
        const pin = el.querySelector(".pin");
        const videoContainer = el.querySelector(".video");
        const video = videoContainer.querySelector("figure");
        const bm = el.querySelector(".bm");
        const socials = el.querySelectorAll(".socials li");
        const logo = el.querySelector(".logo");
        const edition = el.querySelector(".edition");

        if (pin) {
          let isReady = false;

          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: el,
              pin,
              start: "top top",
              end: "+=100%",
              scrub: 1,
              onRefresh(self) {
                if (isReady) return; // ne s'exécute qu'une fois

                isReady = true;

                setTimeout(() => {
                  el.classList.add("is-ready");
                }, 550);
              },
            },
          });

          tl.to(
            videoContainer,
            {
              width: "calc(100vw + 16px)",
              height: "calc(100vh + 16px)",
              borderRadius: 0,
              duration: 1,
            },
            "start"
          )
            .to(
              bm,
              {
                autoAlpha: 0,
                scale: 1.25,
                duration: 0.4,
              },
              "start"
            )
            .to(
              video,
              {
                borderRadius: 0,
                width: "100vw",
                height: "100vh",
                duration: 1,
              },
              "start"
            )
            .to(
              socials,
              {
                stagger: 0.05,
                duration: 0.3,
                scale: 0,
                autoAlpha: 0,
              },
              "start"
            )
            .to(
              edition,
              {
                marginTop: 0,
                autoAlpha: 1,
                duration: 0.1,
              },
              "start+=0.6"
            )
            .to(
              logo,
              {
                scale: 1,
                autoAlpha: 1,
                duration: 0.2,
              },
              "start+=0.6"
            );
        }
      });
    }
  }

  marquee() {
    const elts = document.querySelectorAll(".marquee:not(.ready)");

    if (elts) {
      elts.forEach((el) => {
        el.classList.add("ready");
        const line = el.querySelector(".line");

        const scrollDirection = Number(el.dataset.dir ? el.dataset.dir : 1); // 1 = gauche, -1 = droite
        const speed = 40; // Pixels par seconde

        // Duplique les images pour un effet continu
        const images = line.innerHTML;
        line.innerHTML += images;
        this.lazyload.update();

        // Calcule la largeur totale de la marquee
        const marqueeWidth = line.scrollWidth / 2;

        // Initialise la position
        let position = 0;

        let cursor = 0;

        // Animation continue
        const animate = (timestamp) => {
          position += (speed / 100) * -scrollDirection; // Ajuste selon la vitesse et direction

          // Réinitialise la position si elle dépasse la largeur totale
          if (position <= -marqueeWidth) {
            position = 0;
          } else if (position >= 0) {
            position = -marqueeWidth;
          }

          line.style.transform = `translateX(${position}px)`;
          cursor = requestAnimationFrame(animate);
        };

        // Écouteur pour changer la direction en fonction du scroll
        let lastScrollY = window.scrollY;
        window.addEventListener("scroll", () => {
          const currentScrollY = window.scrollY;
          if (currentScrollY > lastScrollY) {
            // scrollDirection = Number(el.dataset.dir ? el.dataset.dir : 1); // Scroll vers le bas : gauche
          } else if (currentScrollY < lastScrollY) {
            // scrollDirection = -Number(el.dataset.dir ? el.dataset.dir : 1); // Scroll vers le haut : droite
          }
          lastScrollY = currentScrollY;
        });

        if (el.dataset.hover) {
          el.addEventListener("mouseenter", () => {
            cancelAnimationFrame(cursor);
          });
          el.addEventListener("mouseleave", () => {
            cursor = requestAnimationFrame(animate);
          });
        }

        // Lance l'animation
        cursor = requestAnimationFrame(animate);
      });
    }
  }

  tilt() {
    VanillaTilt.init(document.querySelectorAll(".js-tilt"), {
      max: 14,
      speed: 200,
    });
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
